import { render } from "./PlaceholderBox.vue?vue&type=template&id=dde59d04"
import script from "./PlaceholderBox.vue?vue&type=script&lang=js"
export * from "./PlaceholderBox.vue?vue&type=script&lang=js"
script.render = render

export default script